import React, { useEffect, useState } from 'react';

import useBackendStatus from '../../hooks/useBackendStatus';
import MaintenancePage from './MaintenancePage';

/** Query parameter used to preview the maintenance screen on a running environment. */
const PREVIEW_PARAM = 'preview-maintenance';

const isPreviewRequested = (): boolean => {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).has(PREVIEW_PARAM);
};

/**
 * Replaces the whole application with the maintenance screen while the gateway API is down.
 *
 * It sits above the app providers on purpose: nothing below it mounts during an outage, so no
 * component keeps firing requests that cannot succeed. Once shown, the screen stays until it
 * reloads the page itself — a client that lived through a deploy should come back on fresh code.
 */
const MaintenanceGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const status = useBackendStatus();
  const [preview] = useState<boolean>(isPreviewRequested);
  const [latched, setLatched] = useState<boolean>(false);

  useEffect(() => {
    if (status === 'down') setLatched(true);
  }, [status]);

  if (preview) return <MaintenancePage preview />;
  if (latched) return <MaintenancePage />;

  return <>{children}</>;
};

export default MaintenanceGate;
